import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconUpload = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M8 5l3 3H9v5H7V8H5l3-3zm0-5a4.002 4.002 0 013.875 3.003L12 3a4 4 0 11-.999 7.874L11 9h1l.15-.005a2 2 0 00.153-3.972l-.154-.018L12 5l-2.268.001a2 2 0 10-3.543-.151l.08.151L4 5l-.15.005a2 2 0 00-1.844 1.838L2 7l.005.15a2 2 0 001.838 1.844L4 9h1v1.874a4 4 0 11-.874-7.872A4.001 4.001 0 018 0z"
          id="upload_svg__a"
        />
      </defs>
      <g transform="translate(0 1)" fill="none" fillRule="evenodd">
        <mask id="upload_svg__b" fill="#fff">
          <use xlinkHref="#upload_svg__a" />
        </mask>
        <use fill="#000" xlinkHref="#upload_svg__a" />
        <path fill={color} mask="url(#upload_svg__b)" d="M-5-5h25v25H-5z" />
      </g>
    </>
  ),
})``;

export default IconUpload;
